import Wrap from './styles';

/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';

/**
 * Wrapper para conteúdos que só deve ser exibidos no Mobile
 */
const Mobile = ({ children }) => {
  return <Wrap>{children}</Wrap>;
};

Mobile.propTypes = {
  children: PropTypes.any,
};

Mobile.properties = {
  ignore: true,
};

export default Mobile;
